import React from "react";
import { useWatch } from "react-hook-form";
import "./TextareaInput.css";
import { useTranslation } from "react-i18next";

const TextareaInput = ({
  name,
  errors,
  register,
  label,
  type,
  mandatory,
  value,
  disabled = false,
  maxLength,
  control,
}) => {
  const { onChange, ...registerParams } = register(name);
  const { t } = useTranslation();
  const currentValue = useWatch({ control, name });
  return (
    <div className="input_text-form">
      <label>
        {t(label)}
        {mandatory && <span className="asterisk">*</span>}
      </label>
      <textarea

        autoComplete="off"
        className={`form_text_area form-control form-control-sm ${errors[name] ? "error__border--color" : "form__input--area"
          }`}
        type={type}
        maxLength={maxLength}
        onChange={(event) => {
          onChange(event);
        }}
        {...registerParams}
        disabled={disabled}
      />
      {maxLength ? (
        <div className="char__count--message">
          {(currentValue || "").length}/{maxLength}
        </div>
      ) : null}
      <div className="error__message">{errors[name]?.message}</div>
    </div>
  );
};

export default TextareaInput;
